/**
 * Do not edit directly
 * Generated on Thu, 30 May 2024 15:02:21 GMT
 */ const dtcgTokens = {
    "SwanBaseBorderRadius0": "var(--swan-base-border-radius-0)",
    "SwanBaseBorderRadius100": "var(--swan-base-border-radius-100)",
    "SwanBaseBorderRadius200": "var(--swan-base-border-radius-200)",
    "SwanBaseBorderRadius300": "var(--swan-base-border-radius-300)",
    "SwanBaseBorderRadius400": "var(--swan-base-border-radius-400)",
    "SwanBaseBorderRadiusMax": "var(--swan-base-border-radius-max)",
    "SwanBaseBorderWidth0": "var(--swan-base-border-width-0)",
    "SwanBaseBorderWidth100": "var(--swan-base-border-width-100)",
    "SwanBaseBorderWidth200": "var(--swan-base-border-width-200)",
    "SwanBaseBorderWidth300": "var(--swan-base-border-width-300)",
    "SwanBaseBreakpointXsStart": "var(--swan-base-breakpoint-xs-start)",
    "SwanBaseBreakpointXsEnd": "var(--swan-base-breakpoint-xs-end)",
    "SwanBaseBreakpointSmStart": "var(--swan-base-breakpoint-sm-start)",
    "SwanBaseBreakpointSmEnd": "var(--swan-base-breakpoint-sm-end)",
    "SwanBaseBreakpointMdStart": "var(--swan-base-breakpoint-md-start)",
    "SwanBaseBreakpointMdEnd": "var(--swan-base-breakpoint-md-end)",
    "SwanBaseBreakpointLgStart": "var(--swan-base-breakpoint-lg-start)",
    "SwanBaseBreakpointLgEnd": "var(--swan-base-breakpoint-lg-end)",
    "SwanBaseBreakpointXlStart": "var(--swan-base-breakpoint-xl-start)",
    "SwanBaseColorTransparent": "var(--swan-base-color-transparent)",
    "SwanBaseColorBlack": "var(--swan-base-color-black)",
    "SwanBaseColorBlackOpacity90": "var(--swan-base-color-black-opacity-90)",
    "SwanBaseColorBlackOpacity80": "var(--swan-base-color-black-opacity-80)",
    "SwanBaseColorBlackOpacity70": "var(--swan-base-color-black-opacity-70)",
    "SwanBaseColorBlackOpacity60": "var(--swan-base-color-black-opacity-60)",
    "SwanBaseColorBlackOpacity50": "var(--swan-base-color-black-opacity-50)",
    "SwanBaseColorBlackOpacity40": "var(--swan-base-color-black-opacity-40)",
    "SwanBaseColorBlackOpacity30": "var(--swan-base-color-black-opacity-30)",
    "SwanBaseColorBlackOpacity20": "var(--swan-base-color-black-opacity-20)",
    "SwanBaseColorBlackOpacity10": "var(--swan-base-color-black-opacity-10)",
    "SwanBaseColorGrey100": "var(--swan-base-color-grey-100)",
    "SwanBaseColorGrey200": "var(--swan-base-color-grey-200)",
    "SwanBaseColorGrey300": "var(--swan-base-color-grey-300)",
    "SwanBaseColorGrey400": "var(--swan-base-color-grey-400)",
    "SwanBaseColorGrey500": "var(--swan-base-color-grey-500)",
    "SwanBaseColorGrey600": "var(--swan-base-color-grey-600)",
    "SwanBaseColorGrey700": "var(--swan-base-color-grey-700)",
    "SwanBaseColorGrey800": "var(--swan-base-color-grey-800)",
    "SwanBaseColorGrey900": "var(--swan-base-color-grey-900)",
    "SwanBaseColorWhite": "var(--swan-base-color-white)",
    "SwanBaseColorWhiteOpacity90": "var(--swan-base-color-white-opacity-90)",
    "SwanBaseColorWhiteOpacity80": "var(--swan-base-color-white-opacity-80)",
    "SwanBaseColorWhiteOpacity70": "var(--swan-base-color-white-opacity-70)",
    "SwanBaseColorWhiteOpacity60": "var(--swan-base-color-white-opacity-60)",
    "SwanBaseColorWhiteOpacity50": "var(--swan-base-color-white-opacity-50)",
    "SwanBaseColorWhiteOpacity40": "var(--swan-base-color-white-opacity-40)",
    "SwanBaseColorWhiteOpacity30": "var(--swan-base-color-white-opacity-30)",
    "SwanBaseColorWhiteOpacity20": "var(--swan-base-color-white-opacity-20)",
    "SwanBaseColorWhiteOpacity10": "var(--swan-base-color-white-opacity-10)",
    "SwanBaseColorRed100": "var(--swan-base-color-red-100)",
    "SwanBaseColorRed400": "var(--swan-base-color-red-400)",
    "SwanBaseColorRed700": "var(--swan-base-color-red-700)",
    "SwanBaseColorYellow100": "var(--swan-base-color-yellow-100)",
    "SwanBaseColorYellow700": "var(--swan-base-color-yellow-700)",
    "SwanBaseColorYellow900": "var(--swan-base-color-yellow-900)",
    "SwanBaseColorGreen100": "var(--swan-base-color-green-100)",
    "SwanBaseColorGreen400": "var(--swan-base-color-green-400)",
    "SwanBaseColorGreen700": "var(--swan-base-color-green-700)",
    "SwanBaseColorBlue400": "var(--swan-base-color-blue-400)",
    "SwanBaseColorBlue700": "var(--swan-base-color-blue-700)",
    "SwanSemBorderRadiusNone": "var(--swan-sem-border-radius-none)",
    "SwanSemBorderRadiusSubtle": "var(--swan-sem-border-radius-subtle)",
    "SwanSemBorderRadiusStandard": "var(--swan-sem-border-radius-standard)",
    "SwanSemBorderRadiusStrong": "var(--swan-sem-border-radius-strong)",
    "SwanSemBorderRadiusRounded": "var(--swan-sem-border-radius-rounded)",
    "SwanSemBorderRadiusFocus": "var(--swan-sem-border-radius-focus)",
    "SwanSemBorderRadiusAction": "var(--swan-sem-border-radius-action)",
    "SwanSemBorderRadiusInput": "var(--swan-sem-border-radius-input)",
    "SwanSemBorderRadiusContainer": "var(--swan-sem-border-radius-container)",
    "SwanSemBorderWidthNone": "var(--swan-sem-border-width-none)",
    "SwanSemBorderWidthStandard": "var(--swan-sem-border-width-standard)",
    "SwanSemBorderWidthStrong": "var(--swan-sem-border-width-strong)",
    "SwanSemBorderWidthStronger": "var(--swan-sem-border-width-stronger)",
    "SwanSemBorderWidthInput": "var(--swan-sem-border-width-input)",
    "SwanSemBorderWidthAction": "var(--swan-sem-border-width-action)",
    "SwanSemBorderWidthPartition": "var(--swan-sem-border-width-partition)",
    "SwanSemBorderWidthFloating": "var(--swan-sem-border-width-floating)",
    "SwanSemColorBgNone": "var(--swan-sem-color-bg-none)",
    "SwanSemColorBgNoneHover": "var(--swan-sem-color-bg-none-hover)",
    "SwanSemColorBgNoneActive": "var(--swan-sem-color-bg-none-active)",
    "SwanSemColorBgStandard": "var(--swan-sem-color-bg-standard)",
    "SwanSemColorBgHover": "var(--swan-sem-color-bg-hover)",
    "SwanSemColorBgActive": "var(--swan-sem-color-bg-active)",
    "SwanSemColorBgStrong": "var(--swan-sem-color-bg-strong)",
    "SwanSemColorBgStrongHover": "var(--swan-sem-color-bg-strong-hover)",
    "SwanSemColorBgStrongActive": "var(--swan-sem-color-bg-strong-active)",
    "SwanSemColorBgDisabled": "var(--swan-sem-color-bg-disabled)",
    "SwanSemColorBgSelected": "var(--swan-sem-color-bg-selected)",
    "SwanSemColorBgSelectedHover": "var(--swan-sem-color-bg-selected-hover)",
    "SwanSemColorBgSelectedActive": "var(--swan-sem-color-bg-selected-active)",
    "SwanSemColorBgAccent": "var(--swan-sem-color-bg-accent)",
    "SwanSemColorBgError": "var(--swan-sem-color-bg-error)",
    "SwanSemColorBgWarning": "var(--swan-sem-color-bg-warning)",
    "SwanSemColorBgSuccess": "var(--swan-sem-color-bg-success)",
    "SwanSemColorBgPromo": "var(--swan-sem-color-bg-promo)",
    "SwanSemColorBgHelp": "var(--swan-sem-color-bg-help)",
    "SwanSemColorBgAction": "var(--swan-sem-color-bg-action)",
    "SwanSemColorBgActionHover": "var(--swan-sem-color-bg-action-hover)",
    "SwanSemColorBgActionActive": "var(--swan-sem-color-bg-action-active)",
    "SwanSemColorBgControl": "var(--swan-sem-color-bg-control)",
    "SwanSemColorBgControlHover": "var(--swan-sem-color-bg-control-hover)",
    "SwanSemColorBgControlActive": "var(--swan-sem-color-bg-control-active)",
    "SwanSemColorBgInput": "var(--swan-sem-color-bg-input)",
    "SwanSemColorBgContainer": "var(--swan-sem-color-bg-container)",
    "SwanSemColorBgPage": "var(--swan-sem-color-bg-page)",
    "SwanSemColorBorderNone": "var(--swan-sem-color-border-none)",
    "SwanSemColorBorderNoneHover": "var(--swan-sem-color-border-none-hover)",
    "SwanSemColorBorderNoneActive": "var(--swan-sem-color-border-none-active)",
    "SwanSemColorBorderStandard": "var(--swan-sem-color-border-standard)",
    "SwanSemColorBorderHover": "var(--swan-sem-color-border-hover)",
    "SwanSemColorBorderActive": "var(--swan-sem-color-border-active)",
    "SwanSemColorBorderStrong": "var(--swan-sem-color-border-strong)",
    "SwanSemColorBorderStrongHover": "var(--swan-sem-color-border-strong-hover)",
    "SwanSemColorBorderStrongActive": "var(--swan-sem-color-border-strong-active)",
    "SwanSemColorBorderDisabled": "var(--swan-sem-color-border-disabled)",
    "SwanSemColorBorderSelected": "var(--swan-sem-color-border-selected)",
    "SwanSemColorBorderSelectedHover": "var(--swan-sem-color-border-selected-hover)",
    "SwanSemColorBorderSelectedActive": "var(--swan-sem-color-border-selected-active)",
    "SwanSemColorBorderAccent": "var(--swan-sem-color-border-accent)",
    "SwanSemColorBorderError": "var(--swan-sem-color-border-error)",
    "SwanSemColorBorderWarning": "var(--swan-sem-color-border-warning)",
    "SwanSemColorBorderSuccess": "var(--swan-sem-color-border-success)",
    "SwanSemColorBorderPromo": "var(--swan-sem-color-border-promo)",
    "SwanSemColorBorderHelp": "var(--swan-sem-color-border-help)",
    "SwanSemColorBorderAction": "var(--swan-sem-color-border-action)",
    "SwanSemColorBorderActionHover": "var(--swan-sem-color-border-action-hover)",
    "SwanSemColorBorderActionActive": "var(--swan-sem-color-border-action-active)",
    "SwanSemColorBorderControl": "var(--swan-sem-color-border-control)",
    "SwanSemColorBorderControlHover": "var(--swan-sem-color-border-control-hover)",
    "SwanSemColorBorderControlActive": "var(--swan-sem-color-border-control-active)",
    "SwanSemColorBorderInput": "var(--swan-sem-color-border-input)",
    "SwanSemColorBorderInputHover": "var(--swan-sem-color-border-input-hover)",
    "SwanSemColorBorderInputActive": "var(--swan-sem-color-border-input-active)",
    "SwanSemColorBorderContainer": "var(--swan-sem-color-border-container)",
    "SwanSemColorBorderPartition": "var(--swan-sem-color-border-partition)",
    "SwanSemColorTextStandard": "var(--swan-sem-color-text-standard)",
    "SwanSemColorTextSubtle": "var(--swan-sem-color-text-subtle)",
    "SwanSemColorTextInput": "var(--swan-sem-color-text-input)",
    "SwanSemColorTextPlaceholder": "var(--swan-sem-color-text-placeholder)",
    "SwanSemColorTextError": "var(--swan-sem-color-text-error)",
    "SwanSemColorTextWarning": "var(--swan-sem-color-text-warning)",
    "SwanSemColorTextDisabled": "var(--swan-sem-color-text-disabled)",
    "SwanSemColorTextPromo": "var(--swan-sem-color-text-promo)",
    "SwanSemColorTextHover": "var(--swan-sem-color-text-hover)",
    "SwanSemColorTextActive": "var(--swan-sem-color-text-active)",
    "SwanSemElevationNone": "var(--swan-sem-elevation-none)",
    "SwanSemElevationSubtle": "var(--swan-sem-elevation-subtle)",
    "SwanSemElevationStandard": "var(--swan-sem-elevation-standard)",
    "SwanSemElevationStrong": "var(--swan-sem-elevation-strong)",
    "SwanSemElevationFloating": "var(--swan-sem-elevation-floating)",
    "SwanSemElevationOverlay": "var(--swan-sem-elevation-overlay)",
    "SwanSemElevationScrollHorizontal": "var(--swan-sem-elevation-scroll-horizontal)",
    "SwanSemFocusColorInner": "var(--swan-sem-focus-color-inner)",
    "SwanSemFocusColorOuter": "var(--swan-sem-focus-color-outer)",
    "SwanSemFocusStandard": "var(--swan-sem-focus-standard)",
    "SwanSemFocusInset": "var(--swan-sem-focus-inset)",
    "SwanSemFocusTight": "var(--swan-sem-focus-tight)",
    "SwanSemMqEqXl": "'only screen and (min-width: 1920px)'",
    "SwanSemMqEqLg": "'only screen and (min-width: 1440px) and (max-width: 1919px)'",
    "SwanSemMqEqMd": "'only screen and (min-width: 1024px) and (max-width: 1439px)'",
    "SwanSemMqEqSm": "'only screen and (min-width: 768px) and (max-width: 1023px)'",
    "SwanSemMqEqXs": "'only screen and (max-width: 767px)'",
    "SwanSemMqGtXl": "'only screen and (min-width: 1920px)'",
    "SwanSemMqGtLg": "'only screen and (min-width: 1920px)'",
    "SwanSemMqGtMd": "'only screen and (min-width: 1440px)'",
    "SwanSemMqGtSm": "'only screen and (min-width: 1024px)'",
    "SwanSemMqGtXs": "'only screen and (min-width: 768px)'",
    "SwanSemMqGteXl": "'only screen and (min-width: 1920px)'",
    "SwanSemMqGteLg": "'only screen and (min-width: 1440px)'",
    "SwanSemMqGteMd": "'only screen and (min-width: 1024px)'",
    "SwanSemMqGteSm": "'only screen and (min-width: 768px)'",
    "SwanSemMqGteXs": "'only screen and (min-width: 0px)'",
    "SwanSemMqLtXl": "'only screen and (max-width: 1919px)'",
    "SwanSemMqLtLg": "'only screen and (max-width: 1439px)'",
    "SwanSemMqLtMd": "'only screen and (max-width: 1023px)'",
    "SwanSemMqLtSm": "'only screen and (max-width: 767px)'",
    "SwanSemMqLtXs": "'only screen and (max-width: 0px)'",
    "SwanSemMqLteXl": "'only screen'",
    "SwanSemMqLteLg": "'only screen and (max-width: 1919px)'",
    "SwanSemMqLteMd": "'only screen and (max-width: 1439px)'",
    "SwanSemMqLteSm": "'only screen and (max-width: 1023px)'",
    "SwanSemMqLteXs": "'only screen and (max-width: 767px)'",
    "SwanSemZIndexRaised": "var(--swan-sem-z-index-raised)",
    "SwanSemZIndexLinkCovering": "var(--swan-sem-z-index-link-covering)",
    "SwanSemZIndexOverlay": "var(--swan-sem-z-index-overlay)",
    "SwanSemZIndexFloating": "var(--swan-sem-z-index-floating)",
    "SwanSemZIndexOverTheTop": "var(--swan-sem-z-index-over-the-top)",
    "SwanCompAlertBoxColorBg": "var(--swan-comp-alert-box-color-bg)",
    "SwanCompAlertBoxColorTextInverse": "var(--swan-comp-alert-box-color-text-inverse)",
    "SwanCompAlertBoxLegalColorBg": "var(--swan-comp-alert-box-legal-color-bg)",
    "SwanCompAlertBoxLegalColorText": "var(--swan-comp-alert-box-legal-color-text)",
    "SwanCompAlertBoxWarningColorText": "var(--swan-comp-alert-box-warning-color-text)",
    "SwanCompAnchorBarListScrollBarColorBorder": "var(--swan-comp-anchor-bar-list-scroll-bar-color-border)",
    "SwanCompBannerColorBg": "var(--swan-comp-banner-color-bg)",
    "SwanCompBannerLeftHandNavigationColorBg": "var(--swan-comp-banner-left-hand-navigation-color-bg)",
    "SwanCompBannerLeftHandNavigationColorText": "var(--swan-comp-banner-left-hand-navigation-color-text)",
    "SwanCompBannerLeftHandNavigationDividerColorBorder": "var(--swan-comp-banner-left-hand-navigation-divider-color-border)",
    "SwanCompBannerLeftHandNavigationFocus": "var(--swan-comp-banner-left-hand-navigation-focus)",
    "SwanCompBannerTextContainerColorBg": "var(--swan-comp-banner-text-container-color-bg)",
    "SwanCompButtonPrimaryColorBg": "var(--swan-comp-button-primary-color-bg)",
    "SwanCompButtonPrimaryColorBgHover": "var(--swan-comp-button-primary-color-bg-hover)",
    "SwanCompButtonPrimaryColorBgActive": "var(--swan-comp-button-primary-color-bg-active)",
    "SwanCompButtonPrimaryColorBorder": "var(--swan-comp-button-primary-color-border)",
    "SwanCompButtonPrimaryColorBorderHover": "var(--swan-comp-button-primary-color-border-hover)",
    "SwanCompButtonPrimaryColorBorderActive": "var(--swan-comp-button-primary-color-border-active)",
    "SwanCompButtonPrimaryColorText": "var(--swan-comp-button-primary-color-text)",
    "SwanCompButtonClearSelectionColorBgActive": "var(--swan-comp-button-clear-selection-color-bg-active)",
    "SwanCompButtonbarColorBg": "var(--swan-comp-buttonbar-color-bg)",
    "SwanCompCalloutColorBgInverse": "var(--swan-comp-callout-color-bg-inverse)",
    "SwanCompCalloutColorBorderInverse": "var(--swan-comp-callout-color-border-inverse)",
    "SwanCompCalloutColorTextInverse": "var(--swan-comp-callout-color-text-inverse)",
    "SwanCompCalloutFoilColorText": "var(--swan-comp-callout-foil-color-text)",
    "SwanCompCalloutOverlayColorBg": "var(--swan-comp-callout-overlay-color-bg)",
    "SwanCompCalloutOverlayColorText": "var(--swan-comp-callout-overlay-color-text)",
    "SwanCompCarouselButtonColorBg": "var(--swan-comp-carousel-button-color-bg)",
    "SwanCompCarouselButtonColorBgDisabled": "var(--swan-comp-carousel-button-color-bg-disabled)",
    "SwanCompCarouselButtonColorBorderDisabled": "var(--swan-comp-carousel-button-color-border-disabled)",
    "SwanCompCarouselDotsColorBg": "var(--swan-comp-carousel-dots-color-bg)",
    "SwanCompCarouselDotsColorBgHover": "var(--swan-comp-carousel-dots-color-bg-hover)",
    "SwanCompCarouselDotsColorBgInset": "var(--swan-comp-carousel-dots-color-bg-inset)",
    "SwanCompColorSwatchesCrossbarColorBg": "var(--swan-comp-color-swatches-crossbar-color-bg)",
    "SwanCompColorSwatchesTooltipColorBg": "var(--swan-comp-color-swatches-tooltip-color-bg)",
    "SwanCompColorSwatchesTooltipColorText": "var(--swan-comp-color-swatches-tooltip-color-text)",
    "SwanCompCountColorTextInverse": "var(--swan-comp-count-color-text-inverse)",
    "SwanCompCountAlertColorBg": "var(--swan-comp-count-alert-color-bg)",
    "SwanCompCountAlertColorTextAlert": "var(--swan-comp-count-alert-color-text-alert)",
    "SwanCompListboxColorBgSelected": "var(--swan-comp-listbox-color-bg-selected)",
    "SwanCompModalDialogBackdropColorBg": "var(--swan-comp-modal-dialog-backdrop-color-bg)",
    "SwanCompModalDialogPanelFooterElevation": "var(--swan-comp-modal-dialog-panel-footer-elevation)",
    "SwanCompProgressBarEmptyColorBg": "var(--swan-comp-progress-bar-empty-color-bg)",
    "SwanCompProgressBarFilledColorBg": "var(--swan-comp-progress-bar-filled-color-bg)",
    "SwanCompRadioButtonInnerColorBgDisabled": "var(--swan-comp-radio-button-inner-color-bg-disabled)",
    "SwanCompRangeEmptyColorBg": "var(--swan-comp-range-empty-color-bg)",
    "SwanCompSearchInputClearColorBg": "var(--swan-comp-search-input-clear-color-bg)",
    "SwanCompSelectionSetColorBorder": "var(--swan-comp-selection-set-color-border)",
    "SwanCompSelectionSetColorBorderHover": "var(--swan-comp-selection-set-color-border-hover)",
    "SwanCompSelectionSetColorBorderActive": "var(--swan-comp-selection-set-color-border-active)",
    "SwanCompToggleSwitchColorBgSelected": "var(--swan-comp-toggle-switch-color-bg-selected)",
    "SwanCompToggleSwitchColorBgDisabled": "var(--swan-comp-toggle-switch-color-bg-disabled)",
    "SwanCompToggleSwitchHandleColorBg": "var(--swan-comp-toggle-switch-handle-color-bg)",
    "SwanCompToggleSwitchTrackColorBg": "var(--swan-comp-toggle-switch-track-color-bg)"
};

export { dtcgTokens };
